<form *ngIf="!saving" class="k-form" [formGroup]="form">
  <fieldset class="k-form-fieldset">
    <legend *ngIf="existingStep" class="k-form-legend">{{ 'step_mail_new_name' | i18n }}</legend>
    <kendo-formfield showHint="initial" showErrors="initial">
      <kendo-label [for]="title" [text]=" 'step_new_label_title' | i18n "></kendo-label>
      <input kendoTextBox formControlName="title" #title required />
      <kendo-formhint>{{ 'step_new_formhint_title' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="form.controls.title.errors?.required">{{ 'step_new_formerror_title' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="responsible" [text]="'step_details_responsible' | i18n"></kendo-label>
      <sp-people-picker #responsible formControlName="responsible"></sp-people-picker>
      <kendo-formerror>
        <div *ngIf="form.controls.responsible.errors?.required">{{'step_new_formerror_responsible' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="comment" [text]="'step_details_comment' | i18n"></kendo-label>
      <textarea kendoTextArea formControlName="comment" #comment [autoSize]="true"></textarea>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <div class="k-form-buttons">
      <ece-btn-primary (click)="save()" [text]=" 'step_new_button_save' | i18n "></ece-btn-primary>
      <ece-btn (click)="abort()" [text]=" 'step_new_button_abort' | i18n "></ece-btn>
      &nbsp;
      <ece-btn *ngIf="existingStep" (click)="delete()" [text]=" 'step_edit_button_delete' | i18n"></ece-btn>
    </div>
  </fieldset>
</form>
